enum OrderItemStatus {
  IN_DESIGN = 'in_design',
  IN_CHECK = 'in_check',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
}

export default OrderItemStatus
